import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectors as headerSelector } from "../../state/features/header";
import { Breadcrumb, TreeviewDropdown } from "../../components/CommonComponent";
import "./commoncontrol.scss";
import ShopnowBanner from "../MyFleet/Shopnowbanner";
import { operations as breadcrumboperation } from '../../state/features/common/globalsearch';
import { selectors as globalDataSelector } from "../../state/features/common/globaldata";
import { RESOURCE } from '../../const/resource';
import { useTranslation } from 'react-i18next';
import { mykClearIcon } from '../../assets/images'
import GTMPushEvent from "../../utils/gtminitialize";
import { REGION } from "../../const/linksection";
import { Error } from "@progress/kendo-react-labels";
import Loader from "../Loader";
import { operations as myFleetOperations, selectors as myFleetSelectors } from "../../state/features/myfleet"; 
interface Iprops {
    optionsLocations: Array<any>;
    optionsDistributor: Array<any>;
    breadcrumitems: Array<any>;
    handleOnChange: Function;
    optionsCustomers: Array<any>;
    values: { distributors: string; customer: string; locations: string };
    distributorCheck: boolean;
    customerCheck: boolean;
    locationsCheck: boolean;
    componentsRenderName: string;
    getBreadcrubPageactual: string;
    clearAllFields: Function;
    roleBasedfilterOptions?: any;
    userRoleType?: any;
    isUpdateClick?: any;
    isLoading: boolean;
}

const BreadcrumbComponent = ({ breadcrumitems, roleBasedfilterOptions }: any) => (
    <div className={!roleBasedfilterOptions ? 'Machine_details-breadcrumb col-12 col-md-9' : 'Machine_details-breadcrumb col-12 col-md-12 col-lg-3'}>
        <Breadcrumb items={breadcrumitems} />
    </div>
);

const DropdownComponent = ({ treeNodeFilterProp, treeData, showSearch, className, dropdownClassName, placeholder, value, onChange, error }: any) => (
    <>
        <TreeviewDropdown
            treeData={treeData}
            showSearch={showSearch}
            className={className}
            dropdownClassName={dropdownClassName}
            placeholder={placeholder}
            treeNodeFilterProp={treeNodeFilterProp}
            value={value}
            onChange={onChange}
        />
        <Error>{error}</Error>
    </>
);

const ClearButtonComponent = ({ visibleClearButton, getBreadcrubPageactual, clearAllFields, imgUrl, mykClearIcon, label }: any) =>
(
    visibleClearButton && (
        (getBreadcrubPageactual?.toLowerCase() === "shoppingcart") ? (
            <a className='clearBtnToolbar none shoppingcart' href='/' onClick={(e) => { clearAllFields(); e.preventDefault(); }} title={label}>
                {label}
            </a>
        ) : (
            <a className='clearBtnToolbar none' href='/' onClick={(e) => { clearAllFields(); e.preventDefault(); }}>
                    <img src={imgUrl + mykClearIcon} title={label} className='clearBtnToolbarImg' />
            </a>
        )
    )
);


const CommonControl = (props: Iprops) => {
    const { roleBasedfilterOptions, userRoleType } = props;
    const dispatch = useDispatch();
    const dispatchsetBreadCrumRedirect = breadcrumboperation.dispatchBreadCrumbRedirect(dispatch);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [visibleClearButton, setVisibleClearButton] = useState<boolean>(false);
    const dispatchSetApplyClick = myFleetOperations.dispatchApplyClick(dispatch);
    function _onBreadcrumbItemClicked(item: any) {
        navigate({
            pathname: "/myFleet"
        });
        dispatchsetBreadCrumRedirect(false);
        dispatchSetApplyClick({ applyClick: true });
        window.scrollTo(0, 0)
    }

    const breadcrumitems: any = [
        { text: t(RESOURCE.MyK_BreadcrumbHeader_Home), key: t(RESOURCE.MyK_BreadcrumbHeader_Home), role: 'Home', onClick: _onBreadcrumbItemClicked },
        { text: props.componentsRenderName, key: props.componentsRenderName, isCurrentItem: true },
    ];

    const {
        headercurrentuser,
        myKomatsuRegion
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            myKomatsuRegion: headerSelector.myKomatsuRegion(state),
        })
    );

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: headerSelector.imgbaseUrl(state),
    }));
    const imgUrl = imgBaseUrlSelectors;

    function PromotionViewAll() {
        GTMPushEvent({ Path: "/Shared/_UserProfile", PageName: "Tool Bar", EventName: "Promotions", UserDetails: headercurrentuser, GlobalDropdown: globalData })
        navigate({
            pathname: "/promotionviewall"
        });
    }

    useEffect(() => {
        if (userRoleType?.toLowerCase() == "company" || userRoleType?.toLowerCase() == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor) {
            setVisibleClearButton((props.values.distributors != t(RESOURCE.MyK_Label_AllDistributors)) || (props.values.customer != t(RESOURCE.MyK_Label_AllCustomers)) || (props.values.locations != t(RESOURCE.MyK_Label_AllLocations)))
        }
        else if (userRoleType?.toLowerCase() == "customer" && !headercurrentuser.isWideAreaUser && !headercurrentuser.isMultiDistributor) {
            setVisibleClearButton(props.values.locations != t(RESOURCE.MyK_Label_AllLocations))
        }
        else {
            setVisibleClearButton((props.values.customer != t(RESOURCE.MyK_Label_AllCustomers)) || (props.values.locations != t(RESOURCE.MyK_Label_AllLocations)))
        }

    }, [props.values.distributors, props.values.customer, props.values.locations])

    !roleBasedfilterOptions && document.body.classList.add('RoleBaseUser');

     

    switch (headercurrentuser?.usertype?.name) {
        case "Distributor":
            if (headercurrentuser?.isMultiDistributor == false) {
                document.body.classList.add('DistributorUser')
            }
            break;
        case "Customer":
            if (headercurrentuser?.isWideAreaUser == false) {
                document.body.classList.add('CustomerUser');
            }
            break;
    }

    const getMyFleetCommonControl = () => {
        return (
            <div className="row">
                {props.isLoading && <Loader />}
                <div className={!roleBasedfilterOptions ? "col-12 col-md-12 col-lg-12 col-xl-12 rolebased" : "col-12 col-md-12 col-lg-12 col-xl-8"}>
                    <div className="row">
                        <div className={!roleBasedfilterOptions ? "col-12 col-md-9  Breadcrumbhegith" : 'col-12 Breadcrumbhegith'}>
                            <Breadcrumb items={breadcrumitems} />
                        </div>
                        <div className={!roleBasedfilterOptions ? "col-12 col-md-3" : "col-12"}>
                            <div className='mykHeader-custom'>
                                <ul className={visibleClearButton ? 'mykHeader-custom-ul' : 'mykHeader-custom-ul noclear'}>
                                    {(userRoleType?.toLowerCase() == "company" || userRoleType?.toLowerCase() == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor) ?
                                        <li>
                                            <TreeviewDropdown
                                                treeData={props.optionsDistributor}
                                                showSearch={true}
                                                className={props.distributorCheck ? 'multislectDropdown Distributor' : 'multislectDropdown'}
                                                dropdownClassName={'dropdownListContainer noNested'}
                                                placeholder='Select Distributors'
                                                value={props.values.distributors}
                                                onChange={(title: any, value: any, extra: any) => props.handleOnChange(title, value, 'distributors',  extra?.triggerNode?.props)}
                                            />

                                        </li>
                                        : ''}
                                    {(userRoleType?.toLowerCase() == "customer" && !headercurrentuser.isWideAreaUser && !headercurrentuser.isMultiDistributor) ? '' :
                                        <li>
                                            <TreeviewDropdown
                                                treeData={props.optionsCustomers}
                                                showSearch={true}
                                                treeNodeFilterProp={"title"}
                                                className={props.customerCheck ? 'multislectDropdown Customer' : 'multislectDropdown'}
                                                dropdownClassName={'dropdownListContainer noNested'}
                                                placeholder={'Select Customers'}
                                                value={props.values.customer}
                                                onChange={(title: any, value: any, extra: any) => { props.handleOnChange(title, value, 'customer',  extra?.triggerNode?.props) }}
                                            />
                                        </li>
                                    }
                                    <li>
                                        <TreeviewDropdown
                                            treeData={props.optionsLocations}
                                            showSearch={true}
                                            treeNodeFilterProp={"title"}
                                            className={props.locationsCheck ? 'multislectDropdown Locations' : 'multislectDropdown'}
                                            dropdownClassName={'dropdownListContainer noNested'}
                                            placeholder={'Select Locations'}
                                            value={props.values.locations}
                                            onChange={(title: any, value: any, extra: any) => { props.handleOnChange(title, value, 'locations', extra?.triggerNode?.props) }}
                                        />
                                    </li>
                                </ul>
                                {visibleClearButton &&
                                    <a className='clearBtnToolbar' href='/' onClick={(e) => { props.clearAllFields(); e.preventDefault(); }}> <img src={imgUrl + mykClearIcon} title={t(RESOURCE.MyK_Label_ClearAll)} className='clearBtnToolbarImg' /></a>
                                }
                            </div>


                        </div>
                    </div>
                </div>
                <div className={roleBasedfilterOptions ? "col-12 col-md-12 col-lg-12 col-xl-4 mt-2" : 'd-none'}>
                    <div className='BannerSectionBase'>
                        <ShopnowBanner PromotionViewAll={PromotionViewAll} />
                        {/* <div className='viewAll' title={t(RESOURCE.MyK_Promotion_ViewAll)} onClick={PromotionViewAll}>{t(RESOURCE.MyK_Promotion_ViewAll)}</div> */}
                    </div>
                </div>
            </div>
        )
    }


    const getMyShoppingCartCommonControl = () => {
        const clearLabel = t(RESOURCE.MyK_Label_ClearAll);
        const distributorError = props?.isUpdateClick && (props.values.distributors == t(RESOURCE.MyK_Label_AllDistributors)) ? String(t(RESOURCE.MyK_Label_Required)) : null;
        const customerError = props?.isUpdateClick && (props.values.customer == t(RESOURCE.MyK_Label_AllCustomers)) ? String(t(RESOURCE.MyK_Label_Required)) : "";
        const locationError = props?.isUpdateClick && (props.values.locations == t(RESOURCE.MyK_Label_AllLocations)) ? String(t(RESOURCE.MyK_Label_Required)) : "";
        const IsDsitributoDropdownVisible = () => {
            return (userRoleType?.toLowerCase() == "company" || userRoleType?.toLowerCase() == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor);
        }

        return (
          <div className={!roleBasedfilterOptions ? 'row py-2 bg-white machineDetailFreez rolebased' : 'row py-2 bg-white machineDetailFreez'}>
            <BreadcrumbComponent breadcrumitems={breadcrumitems} roleBasedfilterOptions={roleBasedfilterOptions} />
            <div className={!roleBasedfilterOptions ? 'Machine_details-globaldropdown col-12 col-md-3' : "Machine_details-globaldropdown col-12 col-md-12 col-lg-9"}>
              <div className='mykHeader-custom'>
                <ul className={visibleClearButton ? 'mykHeader-custom-ul' : 'mykHeader-custom-ul noclear'}>
                  {(IsDsitributoDropdownVisible()) && (
                    <li>
                      <DropdownComponent
                        treeData={props.optionsDistributor}
                        showSearch={true}
                        className={props.distributorCheck ? 'multislectDropdown Distributor' : 'multislectDropdown'}
                        dropdownClassName={'dropdownListContainer noNested'}
                        placeholder='Select Distributors'
                        value={props.values.distributors}
                        onChange={(title: any, value: any, extra: any) => props.handleOnChange(title, value, 'distributors', extra?.triggerNode?.props)}
                        error={distributorError}
                      />
                    </li>
                  )}
                  {(userRoleType?.toLowerCase() != "customer" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor) && (
                    <li>
                      <DropdownComponent
                        treeData={props.optionsCustomers}
                        showSearch={true}
                        treeNodeFilterProp={"title"}
                        className={props.customerCheck ? 'multislectDropdown Customer' : 'multislectDropdown'}
                        dropdownClassName={'dropdownListContainer noNested'}
                        placeholder={'Select Customers'}
                        value={props.values.customer}
                        onChange={(title:any, value:any, extra: any) => props.handleOnChange(title, value, 'customer', extra?.triggerNode?.props)}
                        error={customerError}
                      />
                    </li>
                  )}
                  <li>
                    <DropdownComponent
                      treeData={props.optionsLocations}
                      showSearch={true}
                      treeNodeFilterProp={"title"}
                      className={props.locationsCheck ? 'multislectDropdown Locations' : 'multislectDropdown'}
                      dropdownClassName={'dropdownListContainer noNested'}
                      placeholder={'Select Locations'}
                      value={props.values.locations}
                      onChange={(title:any, value:any, extra: any) => props.handleOnChange(title, value, 'locations', extra?.triggerNode?.props)}
                      error={locationError}
                    />
                  </li>
                </ul>
                <ClearButtonComponent
                  visibleClearButton={visibleClearButton}
                  getBreadcrubPageactual={props.getBreadcrubPageactual}
                  clearAllFields={props.clearAllFields}
                  imgUrl={imgUrl}
                  mykClearIcon={mykClearIcon}
                  label={clearLabel}
                />
              </div>
            </div>
          </div>
        );
      };

      return <div>
        {props?.isLoading && <Loader/>}
        {(props.getBreadcrubPageactual?.toLowerCase() == "myfleet" && myKomatsuRegion == REGION.AmericaCorp) ?
            getMyFleetCommonControl()
            :
            getMyShoppingCartCommonControl()
        }
    </div >

};
export default CommonControl;
